import { makeStyles } from "../providers/makeStyles";
import { Box, IconButton } from "@mui/material";
import { Close, Warning } from "@mui/icons-material";
import classNames from "classnames";
import { T } from "components/util/t";
import { Tooltip } from "components/elements/tooltip";

const useDivisionStyles = makeStyles<{
    disabled?: boolean;
    fullWidth?: boolean;
}>((theme, { disabled, fullWidth }) => ({
    division: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(1),
        border: `1px solid ${theme.palette.input.border}`,
        borderRadius: theme.spacing(1),
        width: fullWidth ? "100%" : "60%",
        [theme.breakpoints.down("md")]: {
            width: "100%",
        },
        "& .MuiIconButton-root": {
            color: theme.palette.text.primary,
        },
        opacity: disabled && 0.5,
    },
    divisionName: {
        padding: theme.spacing(1),
    },
}));

type DivisionBoxProps = {
    archived?: boolean;
    className?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    name: string;
    onRemove?: () => void;
};

export const DivisionBox = ({
    archived,
    className,
    disabled,
    fullWidth,
    name,
    onRemove,
}: DivisionBoxProps) => {
    const classes = useDivisionStyles({ fullWidth, disabled });

    return (
        <div className={classNames(classes.division, className)}>
            <div className={classes.divisionName}>{name}</div>
            <Box sx={{ display: "flex" }}>
                {archived && (
                    <Tooltip
                        title={
                            <T>
                                This division has been archived. If you keep it
                                in this event, it will be unarchived.
                            </T>
                        }
                        childrenWrapperClass={`${classes.tooltip} ${className}`}
                    >
                        <IconButton
                            size="small"
                            aria-label="Archived division warning"
                        >
                            <Warning />
                        </IconButton>
                    </Tooltip>
                )}
                {onRemove && (
                    <IconButton
                        size="small"
                        onClick={onRemove}
                        disabled={disabled}
                        aria-label={`Remove ${name}`}
                    >
                        <Close />
                    </IconButton>
                )}
            </Box>
        </div>
    );
};
